export default "__VITE_ASSET__HfniIvLV__"